import moment from "moment";

import "../css/CatalogueItem.css";

export default ({ logo, proveedor, ultimaActualizacion }) => {
  return (
    <div className="catalogue-cell">
      <img src={logo} alt={proveedor} />
      <span>
        Actualizado{" "}
        {moment(ultimaActualizacion, "YYYY-MM-DD").format("DD/MM/YYYY")}
      </span>
    </div>
  );
};
